import { Chip, Paper, TextField } from '@material-ui/core'
import { Autocomplete, FilterOptionsState } from '@material-ui/lab'
import clsx from 'clsx'
import { useCallback, useEffect, useState } from 'react'

function filterOptions(t: string[], state: FilterOptionsState<string>) {
  if (!state.inputValue) {
    return []
  }
  return t
}
export interface Props {
  value: string[]
  options: string[]
  placeholder?: string
  onInput: (value: string, reason: string) => void
  onChange: (newValue: string[]) => void
}
export function Search({ value: initialValue, placeholder, options, onInput, onChange }: Props) {
  const [value, setValue] = useState<string[]>([])
  const [element, setElement] = useState<HTMLDivElement | null>(null)
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null)
  const [, setLeft] = useState(0)
  const [selectedTag, setSelectedTag] = useState(-1)
  const autocompleteRef = useCallback<(node: HTMLDivElement | null) => void>(node => {
    if (node) {
      setElement(node)
      setScrollElement((node.firstElementChild?.firstElementChild as HTMLDivElement) || null)
    }
  }, [])
  useEffect(() => {
    setValue(initialValue)
    if (scrollElement && scrollElement.scrollTo) {
      setLeft(prev => {
        const next = scrollElement.scrollWidth
        if (prev < next) {
          scrollElement.scrollTo({ left: scrollElement.scrollWidth })
        }
        return next
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])
  return (
    <Autocomplete
      className={clsx('faq-filter-search-field')}
      classes={{ popperDisablePortal: 'faq-filter-search-field--disable-portal' }}
      multiple
      ref={autocompleteRef}
      value={value}
      onChange={(_, newValue: string[], reason) => {
        if (reason === 'remove-option') {
          onChange(newValue)
          return
        }
        const last: string | undefined = newValue.pop()
        onChange([...newValue, ...(last || '').split(/\s+/).filter(x => x)])
      }}
      onInputChange={(_, v, r) => {
        onInput(v, r)
      }}
      freeSolo
      options={options}
      filterOptions={filterOptions}
      disableClearable
      disablePortal
      onKeyDown={(a: any) => {
        if (selectedTag === -1) {
          return
        }
        if (a.key === 'ArrowLeft' || a.key === 'ArrowRight') {
          setSelectedTag(-1)
        }
        if (a.key === 'Backspace' || a.key === 'Delete') {
          onChange(value.filter((_, i) => i !== selectedTag))
        }
      }}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => {
          const props: any = getTagProps({ index })
          return (
            <Chip
              classes={{
                root: 'faq-search-tag__box',
                label: 'faq-search-tag__label',
                deleteIcon: 'faq-search-tag__delete-icon',
              }}
              key={option}
              variant="outlined"
              label={option}
              data-testid="search-selected-keyword-chip"
              // clickable
              {...props}
              className={clsx(props.className, 'faq-search-tag', {
                selected: selectedTag === index,
              })}
              onClick={() => {
                setSelectedTag(index)
              }}
            />
          )
        })
      }}
      renderInput={params => {
        return (
          <TextField
            {...params}
            className={clsx('faq-filter-search-field__wrapper')}
            variant="outlined"
            placeholder={placeholder}
          />
        )
      }}
      PaperComponent={(props: any) => {
        return (
          <Paper
            elevation={0}
            {...props}
            className={clsx('faq-filter-search-paper', props.className)}
            style={{ width: element?.clientWidth }}
          />
        )
      }}
      // open
      // debug
    />
  )
}
